<template>
  <div v-if="test">
    <div v-for="(u, ux) in test.units" :key="u._id">
      <div class="bolder">
        <mdb-badge color="primary" class="p-1">평가 영역</mdb-badge> {{u.name}} / {{u.code}}
      </div>
      <mdb-tbl sm>
        <mdb-tbl-head>
          <th>수행 준거</th>
          <th class="text-center" style="width:60px">예</th>
          <th class="text-center" style="width:60px">아니오</th>
        </mdb-tbl-head>
        <mdb-tbl-body>
          <tr v-for="(c,ix) in u.content " :key="ix">
            <td style="font-size: 15px">{{c}}</td>
            <td class="text-center" >
              <span v-if="answer.units[ux].answer[ix]"><mdb-icon far icon="circle" /></span>
            </td>
            <td class="text-center" >
              <span v-if="!answer.units[ux].answer[ix]"><mdb-icon far icon="circle" /></span>
            </td>
          </tr>
        </mdb-tbl-body>
      </mdb-tbl>
    </div>
  </div>
</template>
<script>
import { } from 'mdbvue';
import { mapState } from 'vuex';
export default {
  name: 'PerformSelfTestView',
  components: {},
  props: ['test', 'answer']
}
</script>
